import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "prevButton", "nextButton"]
  static values = {
    cardWidth: { type: Number, default: 280 },
    gap: { type: Number, default: 16 }
  }

  connect() {
    this.updateButtons()
    this.containerTarget.addEventListener('scroll', () => this.updateButtons())
  }

  scrollPrev() {
    const scrollAmount = this.calculateScrollAmount()
    this.containerTarget.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    })
  }

  scrollNext() {
    const scrollAmount = this.calculateScrollAmount()
    this.containerTarget.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    })
  }

  calculateScrollAmount() {
    const containerWidth = this.containerTarget.clientWidth
    const cardWithGap = this.cardWidthValue + this.gapValue

    // Calculate how many complete cards fit in the viewport
    const cardsPerView = Math.floor(containerWidth / cardWithGap)

    // Ensure at least 1 card scrolls
    const cardsToScroll = Math.max(1, cardsPerView)

    // Return the exact width to scroll
    return cardsToScroll * cardWithGap
  }

  updateButtons() {
    const { scrollLeft, scrollWidth, clientWidth } = this.containerTarget

    // Hide prev button if at start
    if (this.hasPrevButtonTarget) {
      this.prevButtonTarget.style.display = scrollLeft <= 0 ? 'none' : 'flex'
    }

    // Hide next button if at end
    if (this.hasNextButtonTarget) {
      const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 10
      this.nextButtonTarget.style.display = isAtEnd ? 'none' : 'flex'
    }
  }
}
